import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild
} from '@angular/core';
import { ContentAlignType } from '../../../types/common.types';

@Component({
  selector: 'idp-form-alert',
  templateUrl: './form-alert.component.html',
  styleUrls: ['./form-alert.component.scss']
})
export class FormAlertComponent implements AfterViewChecked, OnChanges {
  @ViewChild('alertErrorRef') banner!: ElementRef;
  @Input() contentAlignment: ContentAlignType = 'left';
  @Input() focus = false;
  @Input() message = '';
  @Input() successIcon = false;
  @Input() alertMessages: string[] = [];
  @Input() showCloseButton = false;
  @Input() tabIndex = '0';
  @Output() closePopup: EventEmitter<void> = new EventEmitter<void>();
  focusOnAlert = false;
  @Output() focusOut: EventEmitter<boolean> = new EventEmitter<boolean>();
  ngAfterViewChecked(): void {
    if (this.focusOnAlert) {
      if (this.banner && this.banner.nativeElement) {
        this.banner.nativeElement.setAttribute('tabindex', '0');
        this.banner.nativeElement.focus();
        this.focusOnAlert = false;
      }
    }
  }

  ngOnChanges() {
    this.focusOnAlert = this.focus;
  }

  focusOutAction(event: KeyboardEvent): void {
    event.stopPropagation();
    event.preventDefault();
    if (event.code === 'Tab') {
      this.focusOut.emit();
    }
  }

  onClosePopup() {
    this.closePopup.emit();
  }
}
